// hooks/useFormViewerWizard/patchWizardOrder.ts — PATCH order wizard via RPC.
// Anon DILARANG UPDATE orders langsung (RLS) → lewat update_wizard_order
// (SECURITY DEFINER, whitelist kolom + hanya sourceForm wizard* + status Pending).
import { supabase } from '../../../../supabase/client';

export async function patchWizardOrder(orderId: string, patch: Record<string, any>): Promise<void> {
    const { data, error } = await supabase
        .rpc('update_wizard_order', { p_order_id: orderId, p_patch: patch })
        .abortSignal(AbortSignal.timeout(20000));
    if (error) {
        if (error.message?.includes('WIZARD_FORBIDDEN')) {
            throw new Error('Pesanan ini sudah tidak bisa dilengkapi (bukan order wizard / sudah diproses).');
        }
        if (error.message?.includes('KURIR_DIBLOKIR')) {
            throw new Error('Kurir tersebut tidak mendukung produk ini. Silakan pilih kurir lain.');
        }
        if (error.message?.includes('COD_ONGKIR_MAHAL')) {
            throw new Error('COD tidak tersedia untuk ongkir di atas batas — silakan pilih Transfer Bank atau QRIS.');
        }
        throw new Error(error.message || 'Gagal menyimpan. Silakan coba lagi.');
    }
    if (data !== true) throw new Error('Gagal menyimpan. Silakan coba lagi.');
}

// PATCH identitas fase draft (nama/WA/alamat teks) via RPC khusus.
// update_wizard_order TIDAK whitelist customer/customerPhone → tanpa ini edit
// Step 1 setelah Kembali hilang diam-diam. Hanya Pending + wizard_step1;
// trigger DB amankan alamat asli pertama ke customer_original_address.
export async function patchWizardStep1Identity(orderId: string, patch: {
    customer?: string; customerPhone?: string; shippingAddress?: string;
}): Promise<void> {
    const { data, error } = await supabase
        .rpc('update_wizard_step1_identity', {
            p_order_id: orderId,
            p_customer: patch.customer ?? null,
            p_phone: patch.customerPhone ?? null,
            p_address: patch.shippingAddress ?? null,
        })
        .abortSignal(AbortSignal.timeout(20000));
    if (error) {
        if (error.message?.includes('WIZARD_FORBIDDEN')) {
            throw new Error('Pesanan ini sudah tidak bisa dilengkapi (bukan order wizard / sudah diproses).');
        }
        throw new Error(error.message || 'Gagal menyimpan. Silakan coba lagi.');
    }
    if (data !== true) throw new Error('Gagal menyimpan. Silakan coba lagi.');
}
